import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { sendSmsCode, checkSmsCode } from 'data-providers/mainAnketaProvider';
import { setOtpId, setTimerStart, setViewResendButton } from 'store/confirmSMS';
import { INITIAL_DURATION } from '../constants';

import * as help from '../helpers';

export const useSecondarySMSVerificationPresenter = ({ appId, dealerId, customer }) => {
  const rootDispatch = useDispatch();

  const { otpId, timerStartTime, isViewResendButton } = useSelector((store) => store.confirmSMS);
  const { id: userId } = useSelector((store) => store.user);

  const [isVerification, setIsVerification] = useState(false);

  const remainingTime = help.calculateRemainingTime(timerStartTime, INITIAL_DURATION);

  const verificationCodeHandler = async (code) => {
    if (!otpId) {
      return false;
    }

    setIsVerification(true);
    const result = await checkSmsCode(otpId, code);
    setIsVerification(false);

    return result;
  };

  const resendCodeHandler = async () => {
    if (!appId || !dealerId || !help.checkCustomer(customer)) {
      return;
    }

    rootDispatch(setViewResendButton(false));
    rootDispatch(setTimerStart(Math.floor(Date.now() / 1000)));

    const result = await sendSmsCode({
      appId,
      dealerId,
      data: help.getSmsParams(customer),
      userId,
    });

    rootDispatch(setOtpId(result?.id || null));
  };

  useEffect(() => {
    if (!timerStartTime) {
      return;
    }

    if (remainingTime <= 0 && !isViewResendButton) {
      rootDispatch(setViewResendButton(true));
    }
  }, [timerStartTime]);

  return {
    isViewResendButton,
    isVerification,
    remainingTime,
    INITIAL_DURATION,
    verificationCodeHandler,
    resendCodeHandler,
  };
};
